"use strict";

var _regeneratorRuntime = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSendFiles;

var _react = require("react");

var _downscaleImageToDataURL = _interopRequireDefault(require("../Utils/downscaleImageToDataURL"));

var _useStyleOptions3 = _interopRequireDefault(require("../hooks/useStyleOptions"));

var _useTrackEvent = _interopRequireDefault(require("../hooks/useTrackEvent"));

var _useTrackTiming = _interopRequireDefault(require("../hooks/useTrackTiming"));

var _useWebChatUIContext2 = _interopRequireDefault(require("./internal/useWebChatUIContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function canMakeThumbnail(_ref) {
  var name = _ref.name;
  return /\.(gif|jpe?g|png)$/i.test(name);
}

function makeThumbnail(_x, _x2, _x3, _x4, _x5) {
  return _makeThumbnail.apply(this, arguments);
}

function _makeThumbnail() {
  _makeThumbnail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(file, width, height, contentType, quality) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return (0, _downscaleImageToDataURL.default)(file, width, height, contentType, quality);

          case 3:
            return _context3.abrupt("return", _context3.sent);

          case 6:
            _context3.prev = 6;
            _context3.t0 = _context3["catch"](0);
            console.warn("Web Chat: Failed to downscale image due to ".concat(_context3.t0, "."));

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 6]]);
  }));
  return _makeThumbnail.apply(this, arguments);
}

function useSendFiles() {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      sendFiles = _useWebChatUIContext.sendFiles;

  var _useStyleOptions = (0, _useStyleOptions3.default)(),
      _useStyleOptions2 = _slicedToArray(_useStyleOptions, 1),
      _useStyleOptions2$ = _useStyleOptions2[0],
      enableUploadThumbnail = _useStyleOptions2$.enableUploadThumbnail,
      uploadThumbnailContentType = _useStyleOptions2$.uploadThumbnailContentType,
      uploadThumbnailHeight = _useStyleOptions2$.uploadThumbnailHeight,
      uploadThumbnailQuality = _useStyleOptions2$.uploadThumbnailQuality,
      uploadThumbnailWidth = _useStyleOptions2$.uploadThumbnailWidth;

  var trackEvent = (0, _useTrackEvent.default)();
  var trackTiming = (0, _useTrackTiming.default)();
  return (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(files) {
      var attachments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(files && files.length)) {
                _context2.next = 7;
                break;
              }

              files = [].slice.call(files); // TODO: [P3] We need to find revokeObjectURL on the UI side
              //       Redux store should not know about the browser environment
              //       One fix is to use ArrayBuffer instead of object URL, but that would requires change to DirectLineJS

              _context2.next = 4;
              return Promise.all([].map.call(files, /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
                  var thumbnail;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(enableUploadThumbnail && canMakeThumbnail(file))) {
                            _context.next = 4;
                            break;
                          }

                          _context.next = 3;
                          return trackTiming('sendFiles:makeThumbnail', makeThumbnail(file, uploadThumbnailWidth, uploadThumbnailHeight, uploadThumbnailContentType, uploadThumbnailQuality));

                        case 3:
                          thumbnail = _context.sent;

                        case 4:
                          return _context.abrupt("return", _objectSpread({
                            name: file.name,
                            size: file.size,
                            url: window.URL.createObjectURL(file)
                          }, thumbnail && {
                            thumbnail: thumbnail
                          }));

                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x7) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 4:
              attachments = _context2.sent;
              sendFiles(attachments);
              trackEvent('sendFiles', {
                numFiles: files.length,
                sumSizeInKB: Math.round(files.reduce(function (total, _ref4) {
                  var size = _ref4.size;
                  return total + size;
                }, 0) / 1024)
              });

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x6) {
      return _ref2.apply(this, arguments);
    };
  }(), [enableUploadThumbnail, sendFiles, trackEvent, trackTiming, uploadThumbnailContentType, uploadThumbnailHeight, uploadThumbnailQuality, uploadThumbnailWidth]);
}